import { HTMLProps, forwardRef } from 'react';

import { Grow } from '@material-ui/core';
import {
  Theme,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core/styles';

import classNames from 'classnames';

import { useSectionContext } from './SectionContext';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      marginLeft: 'auto',
      gap: theme.spacing(1),
    },
  });

export interface SectionActionsProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {
  force?: boolean;
}

const SectionActionsMui = forwardRef<HTMLDivElement, SectionActionsProps>(
  (props, ref) => {
    const { force, className, classes, children, ...rest } = props;
    const { expanded } = useSectionContext();

    const showContent = force || expanded;

    return (
      <Grow in={showContent}>
        <div
          ref={ref}
          className={classNames(className, classes.root)}
          {...rest}
        >
          {children}
        </div>
      </Grow>
    );
  },
);

SectionActionsMui.displayName = 'SectionMui.Actions';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore Section and delete. */
export default withStyles(styles)(SectionActionsMui);
